export const SERVICE_NAME = 'ISSS_VYUZITI';
